import React from 'react';

const GenieIcon = (props) => (
  <svg {...props} viewBox='0 0 86 81' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M26.3325 1.41553L54.1116 0.0294519C59.2934 -0.331713 65.0963 2.6663 68.0011 6.95986L83.2796 30.5232C86.1844 34.8168 86.9458 39.7293 84.6686 44.384L72.168 70.7196C69.8909 75.3743 64.8493 78.6748 59.6674 79.0361L31.8884 80.4221C26.7064 80.7834 20.9036 77.7853 17.9988 73.4917L2.72034 49.9284C-0.184394 45.6349 -0.94571 40.7224 1.33139 36.0676L13.832 9.73202C16.1092 5.0773 21.1506 1.77684 26.3325 1.41553Z'
      fill='#FDBF47'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M44.6741 63.9433C57.8967 63.0187 67.8661 51.5501 66.9415 38.3276C66.0169 25.1051 54.5484 15.1356 41.3258 16.0602C28.1033 16.9848 18.1338 28.4534 19.0584 41.6759C19.983 54.8985 31.4516 64.8679 44.6741 63.9433ZM59.1765 37.3675C59.6339 37.7153 59.9186 38.2432 59.9587 38.8157C59.9987 39.3883 59.7903 39.9519 59.3856 40.3587C57.4572 42.3019 54.0858 45.7 50.94 48.8707L46.5521 53.2933C46.0013 53.8483 45.179 54.0286 44.4464 53.7564C43.7151 53.4842 43.2097 52.8075 43.1552 52.0279L41.4799 28.071C41.4254 27.2914 41.8318 26.551 42.5181 26.1796C43.2044 25.8083 44.045 25.8723 44.6677 26.3452C48.3717 29.1601 54.1751 33.5685 57.7713 36.3001L57.7926 36.3163L59.1765 37.3675ZM41.1768 48.6364L35.4636 54.0687C34.8772 54.6261 34.0044 54.81 33.2288 54.5408C32.4544 54.2716 31.9213 53.5969 31.8668 52.8173L30.1916 28.8604C30.1371 28.0808 30.5711 27.3384 31.3004 26.964C32.0297 26.5897 32.9209 26.6502 33.5792 27.1206L39.9928 31.7049L41.1768 48.6364Z'
      fill='#444A52'
    />
  </svg>
);

export default GenieIcon;
